import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import AltioraNavbar from "./components/AltioraNavbar";
import AltioraFooter from "./components/AltioraFooter";
import AltioraHome from "./altiora-pages/AltioraHome";
import AltioraServices from "./altiora-pages/AltioraServices";
import AltioraIndustries from "./altiora-pages/AltioraIndustries";
import AltioraAbout from "./altiora-pages/AltioraAbout";
import AltioraContact from "./altiora-pages/AltioraContact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AltioraNavbar />
        <Routes>
          <Route path="/" element={<AltioraHome />} />
          <Route path="/services" element={<AltioraServices />} />
          <Route path="/industries" element={<AltioraIndustries />} />
          <Route path="/about" element={<AltioraAbout />} />
          <Route path="/contact" element={<AltioraContact />} />
        </Routes>
        <AltioraFooter />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
